import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: "bg-primary-50", text: "text-primary-600", border: "border-primary-200" },
  accent: { bg: "bg-accent-50", text: "text-accent-600", border: "border-accent-200" },
  secondary: { bg: "bg-secondary-50", text: "text-secondary-600", border: "border-secondary-200" },
};

export default function CategoryNav() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            综艺分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            涵盖搞笑、真人秀、音乐、脱口秀、竞技、旅行等全品类综艺，总有你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl ${colors.bg} border ${colors.border} hover:scale-[1.03] transition-all duration-200 cursor-pointer no-underline`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${colors.bg} ${colors.text}`}>
                  <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
                </div>
                <span className={`text-sm md:text-base font-semibold ${colors.text}`}>
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500">
                  {cat.count}部
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}